import React from "react";
import { OnboardPages, PageMetadata } from "./OnboardPage";

interface Props {
  currentPage: PageMetadata;
}
function OnboardTimeline({ currentPage }: Props) {
  return (
    <div className="relative flex justify-between w-max gap-6 py-4">
      {/* Progress Bar Background */}
      <div className="absolute top-8 left-6 right-6 h-1 bg-gray-200 rounded" />

      {/* Animated Progress Bar */}
      <div
        className="absolute top-8 left-6 h-1 bg-primary rounded transition-all duration-500 ease-in-out"
        style={{
          width: `${((currentPage.number - 1) / (Object.keys(OnboardPages).length - 1)) * 89
            }%`,
        }}
      />

      {/* Timeline Items */}
      {Object.values(OnboardPages).map((pageData) => {
        const isCurrentPage = pageData.number === currentPage.number;
        const isPastPage = pageData.number < currentPage.number;

        return (
          <div
            key={pageData.number}
            className="flex flex-col items-center gap-2"
          >
            {/* Icon Container */}
            <div
              className={`
                relative z-10 p-2 rounded-full 
                transition-all duration-300 ease-in-out
                ${isCurrentPage
                  ? "bg-primary text-white scale-110"
                  : isPastPage
                    ? "bg-primary text-white"
                    : "bg-gray-100 text-gray-400"
                }
              `}
            >
              {pageData.icon}
            </div>

            {/* Title */}
            <p
              className={`
                text-sm font-medium
                transition-all duration-300 ease-in-out
                ${isCurrentPage
                  ? "text-primary scale-105"
                  : isPastPage
                    ? "text-primary"
                    : "text-gray-400"
                }
              `}
            >
              {pageData.iconTitle}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default OnboardTimeline;
